import {SimpleObjectPool} from "./SimpleObjectPool";
import {Mental2SymbolStates, SYMBOL} from "../enums/Enum";
import {Symbol} from "../reels/Symbol";
import {SplitSymbol} from "../reels/SplitSymbol";
import {XWaysSymbol} from "../reels/XWaysSymbol";
import {NudgeSymbol} from "../reels/NudgeSymbol";
import {XHoleSymbol} from "../reels/XHoleSymbol";
import {XGodSymbol} from "../reels/XGodSymbol";
import {TombStoneSymbol} from "../reels/TombStoneSymbol";
import {XMentalSymbol} from "../reels/XMentalSymbol";
import {DeadSymbol} from "../reels/DeadSymbol";

export class GraphicsPool {
    private readonly symbolMap: Map<string, SimpleObjectPool<Symbol>>;

    constructor() {
        this.symbolMap = new Map();

        this.addSymbolPool(SYMBOL.M1);
        this.addSymbolPool(SYMBOL.M2);
        this.addSymbolPool(SYMBOL.M3);
        this.addSymbolPool(SYMBOL.M4);
        this.addSymbolPool(SYMBOL.M5);
        this.addSymbolPool(SYMBOL.L1);
        this.addSymbolPool(SYMBOL.L2);
        this.addSymbolPool(SYMBOL.L3);
        this.addSymbolPool(SYMBOL.L4);
        this.addSymbolPool(SYMBOL.L5);
        this.addSymbolPool(SYMBOL.WILD);
        this.addSymbolPool(SYMBOL.S1);
        this.addSymbolPool(SYMBOL.S2);

        this.addPool(this.symbolMap, () => {
            return new DeadSymbol(SYMBOL.DEAD, Mental2SymbolStates.NORMAL, 0);
        }, SYMBOL.DEAD, 1, 1, 20);

        this.addPool(this.symbolMap, () => {
            return new DeadSymbol(SYMBOL.DEAD_ACTIVE, Mental2SymbolStates.NORMAL, 0);
        }, SYMBOL.DEAD_ACTIVE, 1, 1, 20);

        this.addPool(this.symbolMap, () => {
            return new NudgeSymbol(SYMBOL.X_NUDGE, Mental2SymbolStates.NORMAL, 0);
        }, SYMBOL.X_NUDGE, 1, 1, 3);
        this.addPool(this.symbolMap, () => {
            return new SplitSymbol(SYMBOL.X_SPLIT, Mental2SymbolStates.NORMAL, 0);
        }, SYMBOL.X_SPLIT, 1, 1, 10);
        this.addPool(this.symbolMap, () => {
            return new XWaysSymbol(SYMBOL.X_WAYS, Mental2SymbolStates.NORMAL, 0);
        }, SYMBOL.X_WAYS, 1, 1, 10);
        this.addPool(this.symbolMap, () => {
            return new XHoleSymbol(SYMBOL.X_HOLE, Mental2SymbolStates.NORMAL, 0);
        }, SYMBOL.X_HOLE, 1, 1, 5);
    }

    private static getPool(name: string, map: Map<any, any>): SimpleObjectPool<any> {
        const pool = map.get(name);
        if (pool == undefined) {
            throw new Error(`Cant find pool named:  ${name}`);
        }
        return pool;
    }

    public getSymbolPool(name: string) {
        const pool = this.symbolMap.get(name);
        if (pool == undefined) {
            throw new Error(`Cant find pool named:  ${name}`);
        }
        return pool;
    }

    private addSymbolPool(name: string, size?: number) {
        const pool = new SimpleObjectPool<Symbol>(() => {
            return new Symbol(name, Mental2SymbolStates.NORMAL, 0);
        }, 5, 1, size || 120);
        this.symbolMap.set(name, pool);
    }

    private addPool(map: Map<any, any>, factory: (name: string) => any, poolName: string, startSize: number, growRate: number = 1, maxSize?: number, assetName?: string): SimpleObjectPool<any> {
        const asset = assetName == undefined ? poolName : assetName;
        const pool = new SimpleObjectPool<any>(
            () => {
                return factory(asset)
            },
            startSize,
            growRate,
            maxSize
        );
        if (map.has(poolName)) {
            throw new Error("Pool already exist with name: " + poolName);
        }
        pool.name = poolName;
        map.set(poolName, pool);
        return pool;
    }
}